import appsModule from '@/store/modules/thirdPartyApps/appsModule.js'


export default {
  appsModule
}